import React, { useContext } from 'react';

import { Module } from '../../../../modules/Module';
import { About } from '../../../../sections/About';
import { AltinnProcess } from '../../../../sections/AltinnProcess';
import { AltinnSuccess } from '../../../../sections/AltinnSuccess';
import { AuthenticationMethods } from '../../../../sections/AuthenticationMethods';
import { BubbleForm } from '../../../../sections/BubbleForm';
import { BubbleSection } from '../../../../sections/BubbleSection';
import { ContactForm } from '../../../../sections/ContactForm';
import { GetScoreSection } from '../../../../sections/GetScoreSection';
import { Intro } from '../../../../sections/Intro';
import { ProfileForm } from '../../../../sections/ProfileForm';
import { ScoreAdvantages } from '../../../../sections/ScoreAdvantages';
import { ScoreFactors } from '../../../../sections/ScoreFactors';
import { ScoreGraph } from '../../../../sections/ScoreGraph';
import { ScoreSources } from '../../../../sections/ScoreSources';
import { ScoreSummary } from '../../../../sections/ScoreSummary';
import { SimpleTabs } from '../../../../sections/SimpleTabs';
import { VideoSection } from '../../../../sections/VideoSection';
import { YoutubeVideo } from '../../../../sections/YoutubeVideo';
import { PageContext } from '../../context';

/**
 * Object's keys correspond to Storyblok's section name which are
 * used within Page component
 *
 * Sections are passed to theese components via `props`
 *
 * The LoginBubble is commented out because it still uses hardcoded fields
 * (old implementation) and is not used anywhere in the application.
 */
export const sectionsMap = {
    About,
    AltinnProcess,
    AltinnSuccess,
    AuthenticationMethods,
    BubbleForm,
    BubbleSection,
    ContactForm,

    GetScoreSection,
    /**
     * TODO: Rename following Storyblok sections to be PascalCase, then
     * adjust types (component names)
     */
    intro: Intro,
    module: Module,
    profile_form: ProfileForm,
    score_advantages: ScoreAdvantages,
    score_factors: ScoreFactors,
    score_graph: ScoreGraph,
    score_sources: ScoreSources,
    score_summary: ScoreSummary,
    video_section: VideoSection,
    SimpleTabs,
    YoutubeVideo,
} as Record<string, React.FC<unknown> | React.VFC<unknown>>;

export const Sections = React.memo(function Sections() {
    const { currentPageData } = useContext(PageContext);

    return (
        <>
            {currentPageData.content.sections.map(
                ({ component, _uid, ...sectionProps }: any, index: any) => {
                    const Component = sectionsMap[component] || null;

                    if (!Component) {
                        console.warn(
                            `Section with Storyblok schema name: "${component}" cannot be rendered as one of Sections.`,
                        );
                        return null;
                    }

                    return (
                        <Component
                            key={_uid}
                            data-section-index={index + 1}
                            {...(sectionProps || {})}
                            sectionData={{ ...sectionProps, component }}
                        />
                    );
                },
            )}
        </>
    );
});
